import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Metrics/Domain/queries';
import Component from 'vue-class-component';

@Component
export default class MetricsQueries extends VueCqrs
{
	runMetricsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildMetricsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runResourceMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildResourceMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runRevenueMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildRevenueMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runTotalCostMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildTotalCostMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runCapexMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildCapexMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runMarginCogsMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildMarginCogsMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runExpenseMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildExpenseMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runResourceCostMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildResourceCostMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}

	runCostSubtotalMetricConfigurationQueryV1(workspaceId: number, strategyId: string, metricId: string | null)
	{
		const query = q.buildCostSubtotalMetricConfigurationQueryV1(workspaceId, strategyId, metricId);
		this.$query(query);
	}
}